import type { ProductColor } from '@aloft/toolkit-shared';
import { isUndefined } from '@aloft/toolkit-shared';

import type { ValueFormatter } from '../types.ts';
import { noop } from './formatters/noop.ts';

export const formatValueForCell = (
  val: unknown,
  valueFormatter: ValueFormatter = noop,
): { str: string[]; color?: ProductColor } => {
  if (isUndefined(val)) return { str: [''] };
  return valueFormatter(val);
};
